import axios from 'axios';

import {
  EnhetKildeViewModel,
  FjernKildeCommand,
  KildeDetaljerViewModel,
  TilknyttKildeCommand,
} from './types';

import { getKjederegAdminApiUrl } from '../../';

const baseUrl = getKjederegAdminApiUrl() + '/EnhetKilder';

async function getKilder(enhetId: number): Promise<EnhetKildeViewModel[]> {
  const response = await axios.get<EnhetKildeViewModel[]>(`${baseUrl}/${enhetId}`);
  return response.data;
}

async function tilknytt(command: TilknyttKildeCommand): Promise<EnhetKildeViewModel> {
  const response = await axios.post<EnhetKildeViewModel>(`${baseUrl}/Tilknytt`, command);
  return response.data;
}

async function fjern(command: FjernKildeCommand): Promise<void> {
  await axios.post(`${baseUrl}/Fjern`, command);
}

async function getKildeDetaljer(enhetId: number): Promise<KildeDetaljerViewModel[]> {
  const response = await axios.get<KildeDetaljerViewModel[]>(`${baseUrl}/${enhetId}/Detaljer`);
  return response.data;
}

export default {
  getKilder,
  tilknytt,
  fjern,
  getKildeDetaljer,
};
